import { l } from 'client/Other/Translation'
import * as React from 'react'

const Oops: React.FunctionComponent<{ language: string }> = (props) => {
  const url = `https://support.zervant.com/hc/${props?.language || 'en'}`
  return (
    <h1 className="unexpected-error">
      <a href={url} target="_blank">
        {l('ServerErrorOccured')}
      </a>
    </h1>
  )
}

export default Oops
